/**
 * @description: 仓库管理 - 分仓管理
 * @author: hwx
 * @update: lyr
 */
<template>
    <div class="store-manage-wrap">
        <div class="store-list" v-show="showList">
            <div class="row">
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="storeShop" data-placeholder="请选择门店"></select>
                </div>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="initTable" style="margin-right: 10px">查询</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addStore" v-if="list_menu_add">新增仓库</button>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="store_list"></table>
            </div>
        </div>
        <!-- 新增、修改 -->
        <div class="store-edit" ref="store_edit">
            <div class="row">
                <label class="col-md-3">门店：</label>
                <div class="col-md-9 ct-col">
                    <select class="form-control" ref="store_edit_shop" data-placeholder="请选择门店"></select>
                </div>
            </div>
            <div class="row">
                <label class="col-md-3">仓库名称：</label>
                <div class="col-md-9">
                    <input type="text" class="form-control" v-model="store_edit_name" />
                </div>
            </div>
            <div class="row">
                <label class="col-md-3">存取酒仓库：</label>
                <div class="col-md-9 ct-col">
                    <select class="form-control" data-placeholder="请选择存取酒仓库" ref="store_edit_deposit">
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
            </div>
        </div>
        <!-- 缺货总单列表 -->
        <div class="lack-list" v-show="showLack">
            <h1>缺货总单列表</h1>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addLack">新增缺货总单</button>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="lack_list"></table>
            </div>
        </div>
        <!-- 缺货总单明细 -->
        <div class="lack-det" v-show="showLackDet">
            <h1>缺货总单明细</h1>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="goIngsList">创建补货单</button>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backLack">返回</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="lack_det"></table>
            </div>
        </div>
        <!-- 补货单列表 -->
        <div class="ings-list" v-show="showIngs">
            <h1>补货单列表</h1>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="ings_time">
                        <input type="text" class="form-control laydate-icon" v-model="ings_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="ings_end_time">
                    </div>
                </div>
                <label class="col-md-1 list-label-3">供应商:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ings_agent"></select>
                </div>
                <label class="col-md-1 list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ings_admin"></select>
                </div>
                <label class="col-md-1 list-label-2">状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ings_status">
                        <option value=" ">全部</option>
                        <option value="-1">未发送</option>
                        <option value="1">已发送</option>
                        <option value="2">配送中</option>
                        <option value="3">已完成</option>
                        <option value="4">不予处理</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ingsQuery">查询</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="goRank">查看进货总额排行</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ingsAdd">新建补货单</button>
                    <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backLackDet">返回</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ings_list"></table>
            </div>
        </div>
        <!-- 商品采购进货总额排行 -->
        <div class="ings-rank" v-show="showIngsRank">
            <div class="row row-margin">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIngs">返回</button>
            </div>
            <div class="row">
                <h1>商品采购进货总额排行</h1>
                <p>{{now_shop_name}}</p>
            </div>
            <div class="row">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="rank_time">
                        <input type="text" class="form-control laydate-icon" v-model="rank_start_time"> -
                        <input type="text" class="form-control laydate-icon" v-model="rank_end_time">
                    </div>
                </div>
                <button type="button" class="btn btn-flat btn-middle btn-orange pull-right" @click="rankQuery">查询</button>
            </div>
            <div id="rankChart" style="width: 90%; height: 500px;"></div>
        </div>
        <!-- 新建补货单 -->
        <div class="ings-add" ref="ings_add">
            <div class="row">
                <label class="col-md-3">供应商：</label>
                <div class="col-md-9 ct-col">
                    <select class="form-control" ref="ings_add_agent"></select>
                </div>
            </div>
        </div>
        <!-- 补货单修改、详情 -->
        <div class="ings-det" v-show="showIngsDet">
            <div class="row row-margin">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backIngs">返回</button>
                <div class="pull-right" v-show="ings_modify == '2'">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="addIngsGoods">添加商品</button>
                </div>
                <div class="pull-right" v-show="ings_modify == '3'">
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="getExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="dealIngs('1')">立即发送</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ingsConfirm">确认收货</button>
                    <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ingsDone">一键生成采购进货单</button>
                </div>
            </div>
            <div class="ings-det-head">
                <h2>{{ings_det_tit}}</h2>
                <div class="row row-margin">
                    <div class="col-md-4">
                        <label>单号：</label>
                        <span>{{theIngsDet.item_no}}</span>
                    </div>
                    <div class="col-md-4">
                        <label>门店：</label>
                        <span>{{theIngsDet.shop_name}}</span>
                    </div>
                    <div class="col-md-4">
                        <label>补货操作人：</label>
                        <span>{{theIngsDet.created_by_name}}</span>
                    </div>
                </div>
                <div class="row row-margin">
                    <div class="col-md-4">
                        <label>时间：</label>
                        <span>{{theIngsDet.created_at}}</span>
                    </div>
                    <div class="col-md-4">
                        <label>补货总量：</label>
                        <span>{{theIngsDetTotal}}</span>
                    </div>
                    <div class="col-md-4">
                        <label>补货仓库：</label>
                        <span>{{theIngsDet.store_name}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label>补货供应商：</label>
                        <span>{{theIngsDet.supplier_name}}</span>
                    </div>
                    <div class="col-md-4">
                        <label>补货单状态：</label>
                        <span>{{theIngsDetStatus}}</span>
                    </div>
                    <div class="col-md-4">
                        <label v-show="theIngsDet.status == '4'">不处理原因：</label>
                        <span v-show="theIngsDet.status == '4'">{{theIngsDet.reject_reason}}</span>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ings_det_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ings_det_export">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                            <label>商品单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="quantity">
                            <label>补货数量</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 商品选择 -->
        <div class="ings-goods" ref="ings_goods">
            <div class="row">
                <div class="col-md-3 ct-col clear-pd">
                    <select class="form-control" data-placeholder="请选择类型" ref="ings_goods_type">
                        <option value=""></option>
                    </select>
                </div>
                <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="请输入商品名称" v-model="ings_goods_name" @keyup.13="ingsGoodsQuery" />
                </div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="ingsGoodsQuery">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover" data-pagination="true" ref="ings_goods_list" ></table>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'store_getStoreList',
        data () {
            return {
                shopDatas: [],
                showList: true,
                showLack: false,
                showLackDet: false,
                showIngs: false,
                showIngsRank: false,
                showIngsDet: false,
                modify: '1',
                store_edit_name: "",
                list_menu_add: false,
                list_menu_modify: false,
                list_menu_del: false,
                list_menu_check: false,

                now_shop_id: '',
                now_shop_name: '',
                now_store_id: '',
                lack_id: '',

                ings_purchase_menu: {},
                ings_modify: '',
                ings_start_time: '',
                ings_end_time: '',
                ings_id: '',
                ings_supplier_id: '',
                ings_det_tit: '',
                theIngsDet: {},
                theIngsDetTotal: '',
                theIngsDetStatus: '',
                ingsDetGoods: [],
                ings_goods_name: '',
                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['goods_name', 'goods_unit_name', 'goods_type_name', 'quantity'],
                export_type: 1,

                rank_start_time: '',
                rank_end_time: '',
            }
        },
        computed: {
            menunew() {
				return JSON.parse(this.$store.state.menunew)
			}
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted() {
            let _this = this;

            // 跳转菜单
			_this.getPageMenu();
            _this.innitInput();
            // _this.initTable();
            // 获取权限
            _this.getMenuOp();

            _this.$nextTick(function() {
                // 获取门店
                _this.getStoreShop();
                $(_this.$refs.store_edit_deposit).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
                // 初始化时间
                _this.initStoreDate();
                // 获取供应商
                _this.getStoreSupplier();

                /* 补货单列表 */
                $(_this.$refs.ings_status).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
                // 商品类型
                _this.initGoodsType();
            });
        },
        methods: {
            // 跳转菜单
			getPageMenu: function() {
				this.menunew.forEach(i => {
					if(i.id == '543') {
						i.submenu.forEach(j => {
							if(j.id == '558') {
								// 采购进货
								this.ings_purchase_menu = j
							}
						})
					}
				})
			},
			// 跳转参数
			setPageParams(res) {
				const obj = {
					name: 'purchasing',
					params: {
						purc_id: res.id,
                        purc_shop_id: res.shop_id
					}
				}
				this.$emit("pageLink", this.ings_purchase_menu, obj)
			},
            // 获取权限
            getMenuOp() {
                let _this = this,
                    menu = JSON.parse(this.$store.state.menunew);

                menu.forEach(f => {
                    if(f.id == '543') { // 仓库
                        menu = f.submenu
                        menu.forEach(s => {
                            if(s.id == '555') { // 仓库管理
                                menu = s.submenu
                            }
                        })
                    }
                })
                menu.forEach(_ => {
                    if(_.id == '1124') { // 新增
                        _this.list_menu_add = true
                    }
                    if(_.id == '1125') { // 修改
                        _this.list_menu_modify = true
                    }
                    if(_.id == '1126') { // 删除
                        _this.list_menu_del = true
                    }
                    if(_.id == '1127') { // 查看
                        _this.list_menu_check = true
                    }
                })
            },
            // 门店数据
            getStoreShop: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            arr.shift();

                            $(_this.$refs.store_edit_shop).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this ) ;
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },

            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.storeShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                
                            });
                            $(_this.$refs.storeShop).val(data.response.result[1].id).trigger('change');
                            _this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化时间
            initStoreDate: function() {
                let _this = this;
                $(_this.$refs.ings_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate()
                }, function(start, end, label) {
                    _this.ings_start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.ings_end_time = end.format('YYYY-MM-DD HH:mm');
                });

                $(_this.$refs.rank_time).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate()
                }, function(start, end, label) {
                    _this.rank_start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.rank_end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 供应商数据
            getStoreSupplier: function() {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "0",
                            "page_size": "0"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getSupplier",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: ' ', text: '全部' }];
                            $.each(data.response.result.data.rows, function(k, v) {
                                arr.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ings_agent).html("");
                            $(_this.$refs.ings_agent).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });

                            arr.shift();
                            $(_this.$refs.ings_add_agent).html("");
                            $(_this.$refs.ings_add_agent).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 初始化
            initTable: function() {
                let _this = this;

                $(_this.$refs.store_list).bootstrapTable('destroy');
                $(_this.$refs.store_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getStoreList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "name",
                        title: "名称",
                        width: "25%"
                    }, {
                        field: "deposit",
                        title: "存取酒仓库",
                        width: "25%",
                        formatter: function(value, row, index) {
                            if(row.deposit == 1) {
                                return '是';
                            } else if(row.deposit == -1) {
                                return '否';
                            }
                        }
                    }, {
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .modify': function(e, value, row, index) {
                                _this.modify = '2';
                                $(_this.$refs.store_edit_shop).val(row.shop_id).trigger("change");
                                $(_this.$refs.store_edit_shop).prop("disabled", true);
                                _this.store_edit_name = row.name;
                                $(_this.$refs.store_edit_deposit).val(row.deposit).trigger("change");
                                
                                _this.editStore('修改仓库', row.id);
                            },
                            'click .delete': function(e, value, row) {
                                layer.confirm('删除后当前仓库的库存将会被清零，确定删除？', {
                                    btn: ['确定', '取消'] //按钮
                                }, function() {
                                    _this.delStore(row.id);
                                });
                            },
                            'click .lack': function(e, value, row) {
                                _this.now_shop_id = row.shop_id;
                                _this.now_shop_name = row.shop_name;
                                _this.now_store_id = row.id;
                                _this.initLackTable();
                                _this.showList = false;
                                _this.showLack = true;
                                
                                _this.$nextTick(function() {
                                    // 获取操作人
                                    this.getIngsAdmin();
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            var res = ''
                            if (_this.list_menu_modify) {
                                res += '<span class="text-blue modify">修改</span>'
                            }
                            if (_this.list_menu_del) {
                                res += '<span class="text-blue delete">删除</span>'
                            }
                            if (_this.list_menu_check) {
                                res += '<span class="text-blue lack">查看缺货总单</span>'
                            }
                            return res
                        }
                    }]
                });
            },
            // 获取仓库列表
            getStoreList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": $(_this.$refs.storeShop).val(),
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 点击新增
            addStore: function() {
                let _this = this;

                _this.modify = '1';
                $(_this.$refs.store_edit_shop).val('').trigger('change');
                $(_this.$refs.store_edit_shop).prop("disabled", false);
                _this.store_edit_name = "";
                $(_this.$refs.store_edit_deposit).val("-1").trigger("change");
                
                _this.editStore('添加仓库', '');
            },
            // 新增、修改
            editStore: function(name, id) {
                let _this = this;

                layer.confirm('', {
                    skin: 'add_goods-alert layui-layer-rim',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: [name, true],
                    area: ['600px', ''],
                    content: $(_this.$refs.store_edit),
                    offset: '100px'
                }, function() {
                    let url = Vue.ctUrl + "store/addStore";
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": $(_this.$refs.store_edit_shop).val(),
                                "name": _this.store_edit_name, // 仓库名称
                                "deposit": $(_this.$refs.store_edit_deposit).val()
                            }
                        },
                        "comment": ""
                    };
                    if(_this.modify == '2') {
                        datas["request"]["param"]["id"] = id;
                        url = Vue.ctUrl + "store/updateStore";
                    }
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: url,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            layer.closeAll();
                            if(data.response.result_code == "true") {
                                layer.msg("操作成功");
                                $(_this.$refs.store_list).bootstrapTable("refresh");
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },
            // 删除供应商
            delStore: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/delStore",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg("删除成功！");
                            $(_this.$refs.store_list).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 缺货总单列表
            initLackTable: function() {
                let _this = this;

                $(_this.$refs.lack_list).bootstrapTable('destroy');
                $(_this.$refs.lack_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getLackList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "shop_name",
                        title: "门店",
                        width: "25%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "25%"
                    }, {
                        field: "create_time",
                        title: "操作时间",
                        width: "25%"
                    }, {
                        title: "操作",
                        width: "25%",
                        events: {
                            'click .lack': function(e, value, row) {
                                _this.lack_id = row.id;
                                _this.initLackDetTable();
                                _this.showLack = false;
                                _this.showLackDet = true;
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后不可恢复，是否删除？', {
                                    btn: ['确定', '取消'] //按钮
                                }, function() {
                                    _this.delLack(row.id);
                                });
                            }
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue lack">查看缺货总单明细</span><span class="text-blue del">删除</span>'
                        }
                    }]
                });
            },
            getLackList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": _this.now_shop_id,
                            "store_id": _this.now_store_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getReplenishList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 删除
            delLack(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/delReplenish",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.result.msg || '删除成功');
                            $(_this.$refs.lack_list).bootstrapTable("refresh");
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 新增缺货总单
            addLack: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "store_id": _this.now_store_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/addReplenish",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.lack_list).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 返回列表
            backList: function() {
                this.showList = true;
                this.showLack = false;
            },

            // 缺货总单明细
            initLackDetTable: function() {
                let _this = this;

                $(_this.$refs.lack_det).bootstrapTable('destroy');
                $(_this.$refs.lack_det).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getLackDet(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "store_name",
                        title: "仓库",
                        width: "16%"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "16%"
                    }, {
                        field: "goods_unit_name",
                        title: "商品单位",
                        width: "16%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "16%"
                    }, {
                        field: "stock_total",
                        title: "目前总库存数",
                        width: "16%"
                    }, {
                        field: "current_stock",
                        title: "当前仓库数量",
                        width: "16%"
                    }]
                });
            },
            getLackDet: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "id": _this.lack_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getReplenishDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 跳转到补货单列表
            goIngsList: function() {
                this.ings_start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                this.ings_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                $(this.$refs.ings_agent).val('').trigger('change');
                $(this.$refs.ings_admin).val('').trigger('change');
                $(this.$refs.ings_status).val('').trigger('change');
                this.initIngsTable();

                this.showLackDet = false;
                this.showIngs = true;
            },
            // 返回缺货列表
            backLack: function() {
                this.showLack = true;
                this.showLackDet = false;
            },

            /* 
             * 补货单列表
             */
            // 获取操作人
            getIngsAdmin: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": _this.now_shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            
                            $(_this.$refs.ings_admin).html("");
                            $(_this.$refs.ings_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 补货单列表
            initIngsTable: function() {
                let _this = this;

                $(_this.$refs.ings_list).bootstrapTable('destroy');
                $(_this.$refs.ings_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getIngsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "item_no",
                        title: "补货单号",
                        width: "16%"
                    }, {
                        field: "supplier_name",
                        title: "供应商",
                        width: "16%"
                    }, {
                        field: "admin_name",
                        title: "操作人",
                        width: "16%"
                    }, {
                        field: "created_at",
                        title: "创建时间",
                        width: "16%"
                    }, {
                        field: "status_name",
                        title: "状态",
                        width: "16%"
                    }, {
                        field: "current_stock",
                        title: "操作",
                        width: "16%",
                        events: {
                            'click .modify': function(e, value, row) {
                                _this.ings_modify = '2';
                                _this.ings_det_tit = '修改补货单';
                                _this.ings_id = row.id;
                                _this.ings_supplier_id = row.supplier_id;
                                _this.getIngsDet('detail');
                                _this.showIngs = false;
                                _this.showIngsDet = true;
                            },
                            'click .det': function(e, value, row) {
                                _this.ings_modify = '3';
                                _this.ings_det_tit = '补货单详情';
                                _this.ings_id = row.id;
                                _this.getIngsDet('detail');
                                _this.showIngs = false;
                                _this.showIngsDet = true;
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后不可恢复，是否删除？', {
                                    btn: ['确定', '取消'] //按钮
                                }, function() {
                                    _this.delIngsList(row.id);
                                });
                            },
                        },
                        formatter: function(value, row, index) {
                            if(row.status == '-1') {
                                return '<span class="text-blue modify">修改</span><span class="text-blue det">详情</span><span class="text-blue del">删除</span>'
                            } else {
                                return '<span class="text-blue det">详情</span>'
                            }
                        }
                    }]
                });
            },
            getIngsList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "store_id": _this.now_store_id,
                            "start_time": _this.ings_start_time,
                            "end_time": _this.ings_end_time,
                            "supplier_id": $.trim($(_this.$refs.ings_agent).val()),
                            "admin_id": $.trim($(_this.$refs.ings_admin).val()),
                            "status": $.trim($(_this.$refs.ings_status).val())
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getReplenishOrderList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 查询
            ingsQuery: function() {
                this.initIngsTable();
            },
            // 删除补货单
            delIngsList(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/delReplenishOrder",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            $(_this.$refs.ings_list).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 跳转到排行
            goRank: function() {
                this.rank_start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                this.rank_end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                this.ingsRank();
                this.showIngs = false;
                this.showIngsRank = true;
            },
            // 商品采购进货总额排行
            ingsRank: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "start_time": _this.rank_start_time,
                            "end_time": _this.rank_end_time,
                            "shop_id": _this.now_shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getPurchaseChart",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            // 图表
                            let rankName = [],
                                rankAmount = [];

                            $.each(data.response.result, function(k, v) {
                                rankName.push(v.supplier_name);
                            });
                            $.each(data.response.result, function(k, v) {
                                rankAmount.push(v.amount);
                            });

                            let rankChart = echarts.init(document.getElementById('rankChart'));
                            let option = {
                                title: {
                                    text: ''
                                },
                                legend: {
                                    // data: '100'
                                    // formatter: function() {
                                    //     return rankName.join('');
                                    // }
                                },
                                tooltip: {
                                    trigger: 'axis',
                                    formatter: "{b}:\n{c}"
                                },
                                grid: {
                                    left: '9%',
                                    bottom: '5%',
                                    containLabel: true
                                },
                                xAxis: {
                                    type: 'category',
                                    // boundaryGap: false,
                                    // axisLabel: {
                                    //     rotate: -60
                                    // },
                                    data: rankName
                                },
                                yAxis: {
                                    type: 'value',
                                    name: '商品采购进货总额(单位：元)'
                                },
                                series: [{
                                    type: 'bar',
                                    data: rankAmount
                                }]
                            };
                            rankChart.setOption(option);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 查询排行
            rankQuery: function() {
                this.ingsRank();
            },
            // 返回补货单列表
            backIngs: function() {
                this.showIngs = true;
                this.showIngsRank = false;
                this.showIngsDet = false;
            },
            // 新建补货单
            ingsAdd: function() {
                let _this = this;

                layer.confirm('', {
                    skin: 'add_goods-alert',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: ['新建补货单', true],
                    area: ['560px', ''],
                    content: $(_this.$refs.ings_add),
                    offset: '100px'
                }, function() {
                    let datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "replenish_id": _this.lack_id,
                                "supplier_id": $(_this.$refs.ings_add_agent).val()
                            }
                        },
                        "comment": ""
                    };
                    let datas2 = JSON.stringify(datas);
                    $.ajax({
                        type: "post",
                        dataType: "json",
                        url: Vue.ctUrl + "store/addReplenishOrder",
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        data: {
                            json: datas2
                        },
                        success: function(data) {
                            if(data.response.result_code == "true") {
                                layer.closeAll();
                                layer.msg(data.response.error_msg);
                                $(_this.$refs.ings_list).bootstrapTable('refresh');
                            } else {
                                Vue.timeoutfun(data.response.result_status, _this);
                                layer.msg(data.response.error_msg);
                            }
                        },
                        error: function(err) {
                            layer.msg("出错啦");
                        }
                    });
                });
            },
            // 返回缺货明细
            backLackDet: function() {
                this.showLackDet = true;
                this.showIngs = false;
            },
            // 补货单详情
            getIngsDet: function(api_type) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": _this.ings_id,
                            "api_type": api_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/getReplenishOrderDetail",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.theIngsDet = data.response.result;
                            _this.ingsDetGoods = data.response.result.goods;
                            _this.theIngsDetTotal = data.response.result.amount;
                            _this.theIngsDetStatus = data.response.result.status_name
                            _this.initIngsDetTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 补货单商品
            initIngsDetTable: function(pageNumber) {
                let _this = this;
                $(_this.$refs.ings_det_list).bootstrapTable("destroy");
                $(_this.$refs.ings_det_list).bootstrapTable({
                    pageNumber: pageNumber || 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    columns: [{
                        field: "goods_name",
                        title: "商品名称",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "goods_unit_name",
                        title: "商品单位",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "5%",
                        valign: "middle"
                    }, {
                        field: "quantity",
                        title: "补货数量",
                        width: "12%",
                        valign: "middle",
                        events: {
                            'blur .editableinput': function(e, value, row) {
                                // 数量编辑
                                if(isNaN($(this).text())) {
                                    layer.msg("请输入数字");
                                    $(this).text(value);
                                    return;
                                } else if($(this).text() < 1) {
                                    layer.msg("数量不小于1");
                                    $(this).text(value);
                                    return;
                                } else if($(this).text().indexOf('.') != '-1') {
                                    layer.msg("请输入整数");
                                    $(this).text(value);
                                    return;
                                }
                                
                                $(this).removeClass("editableinput-focus");
                                $(this).attr("contenteditable", false);
                                $(this).next().removeClass("editableiconend");
                                for(let i = 0; i < _this.ingsDetGoods.length; i++) {
                                    if(_this.ingsDetGoods[i].merchant_goods_id == row.merchant_goods_id) {
                                        // 总量
                                        _this.theIngsDetTotal -= (_this.ingsDetGoods[i].quantity - $(this).text());

                                        _this.ingsDetGoods[i].quantity = $(this).text();
                                        _this.editIngsGoods(_this.ingsDetGoods[i], i);
                                    }
                                }
                            },
                            'click .editableicon': function(e, value, row) {
                                $(this).prev().addClass("editableinput-focus");
                                $(this).prev().attr("contenteditable", true);
                                $(this).addClass("editableiconend");
                            }
                        },
                        formatter: function(value) {
                            if(_this.ings_modify == '2') {
                                return '<div class="editableinput quantity" contenteditable="false">' + value + '</div><a class="editableicon"></a>';
                            } else {
                                return value;
                            }
                        }
                    }, {
                        field: "op",
                        title: "操作",
                        width: "6%",
                        valign: "middle",
                        events: {
                            'click .delete': function(e, value, row, index) {
                                layer.confirm("确定删除该商品吗？", {
                                    btn: ['确定', '取消'],
                                }, function() {
                                    for(let i = 0; i < _this.ingsDetGoods.length; i++) {
                                        if(_this.ingsDetGoods[i].merchant_goods_id == row.merchant_goods_id) {
                                            if(_this.ingsDetGoods[i].id != '0') {
                                                _this.delIngsGoods(_this.ingsDetGoods[i].id);
                                            }
                                            _this.ingsDetGoods.splice(i, 1);
                                        }
                                    }

                                    // 刷新滚动条不变
                                    let scollPostion = $('.tab-content').scrollTop();
                                    _this.initIngsDetTable($(_this.$refs.ings_det_list).bootstrapTable('getOptions').pageNumber);
                                    $('.tab-content').scrollTop(scollPostion);
                                    
                                    layer.closeAll();
                                });
                            },
                        },
                        formatter: function(value, row, index) {
                            return '<span class="text-blue delete">删除</span>'
                        }
                    }],
                    data: _this.ingsDetGoods
                });
                if(_this.ings_modify == '3') {
                    $(_this.$refs.ings_det_list).bootstrapTable('hideColumn', 'op');
                }
            },
            // 商品类型
            initGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: "0", text: "全部" }];
                            $.each(data.response.result.data, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.ings_goods_type).select2({
                                data: arr,
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 添加商品
            addIngsGoods: function() {
                let _this = this;
                
                _this.initGoodsTable();
                layer.confirm('', {
                    skin: 'add_goods-alert layui-layer-rim',
                    type: 1,
                    btn: ['确定', '取消'],
                    title: ['添加商品', true],
                    area: ['700px', ''],
                    content: $(_this.$refs.ings_goods),
                    offset: '100px'
                }, function() {
                    $.map($(_this.$refs.ings_goods_list).bootstrapTable('getSelections'), function(row) {
                        for(let i = 0; i < _this.ingsDetGoods.length; i++) {
                            if(_this.ingsDetGoods[i].merchant_goods_id == row.id) {
                                layer.msg("商品已存在");
                                return;
                            }
                        }
                        _this.ingsDetGoods.push({ id: '0',merchant_goods_id: row.id, goods_name: row.goods_name, goods_unit_name: row.goods_unit_name, goods_type_name: row.goods_type_name, quantity: '0' });

                        layer.msg("成功添加商品");
                        _this.initIngsDetTable();
                    });
                });
            },
            // 初始化商品
            initGoodsTable: function() {
                let _this = this;
                $(_this.$refs.ings_goods_list).bootstrapTable('destroy');
                $(_this.$refs.ings_goods_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 5,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getGoodsList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        checkbox: true,
                        title: "全选"
                    }, {
                        field: "goods_type_name",
                        title: "类型"
                    }, {
                        field: "goods_name",
                        title: "名称"
                    }, {
                        field: "goods_unit_name",
                        title: "单位"
                    }],
                    clickToSelect: true
                });
            },
            getGoodsList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params.data.offset != 0) {
                    pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "shop_id": _this.now_shop_id,
                            "supplier_id": _this.ings_supplier_id,
                            "goods_type": $(_this.$refs.ings_goods_type).val(),
                            "goods_name": _this.ings_goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 查询商品
            ingsGoodsQuery: function() {
                this.initGoodsTable();
            },
            // 新增、修改补货单商品
            editIngsGoods: function(ingsDetGoods, i) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "main_id": _this.ings_id,
                            "id": ingsDetGoods.id,
                            "merchant_goods_id": ingsDetGoods.merchant_goods_id,
                            "quantity": ingsDetGoods.quantity
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/updateReplenishGood",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            if(_this.ingsDetGoods[i].id == '0') {
                                _this.ingsDetGoods[i].id = data.response.result.id;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 删除
            delIngsGoods: function(id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "main_id": _this.ings_id,
                            "id": id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/delReplenishGood",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "store/exportReplenishOrderDetail"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ings_det_export)
                }, function() {
                    _this.exportDetail();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 导出
            exportDetail: function() {
                let export_fields = JSON.stringify(this.export_checkModel);
                window.location.href = Vue.ctUrl + "store/exportReplenishOrderDetail?" +
                    "id=" + this.ings_id +
                    "&export_fields=" + export_fields +
                    "&export_type=" + this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 
            ingsConfirm: function() {
                let _this = this;
                layer.confirm('是否立即确认收货？', {
                    btn: ['确定', '取消']
                }, function() {
                    _this.dealIngs('3');
                });
            },
            // 立即发送、确认收货
            dealIngs: function(status) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": _this.ings_id,
                            "status": status
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/dealReplenishOrder",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg(data.response.error_msg);
                            if(status == '1') {
                                _this.theIngsDetStatus = '已发送';
                            } else if(status == '3') {
                                _this.theIngsDetStatus = '已完成';
                            }
                            $(_this.$refs.ings_list).bootstrapTable('refresh');
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 一键生成采购进货单
            ingsDone: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": _this.ings_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "store/replenish2Purchase",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            // layer.msg(data.response.error_msg);
                            layer.msg(data.response.error_msg, {
                                time: 1500
                            }, function() {
                                _this.setPageParams(data.response.result);
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            }

        }
    }
</script>

<style lang="less">
    .store-manage-wrap {
        .pull-right {
            button {
                margin: 0 0 0 30px;
            }
        }
    }
    .store-edit,
    .ings-add {
        display: none;
        width: 70%;
        margin: 20px auto;
        label {
            padding: 0;
            line-height: 32px;
            color: #5e5e5e;
            font-size: 14px;
            text-align: right;
            font-weight: normal;
        }
        .row {
            margin: 0 0 20px;
        }
    }
    .ings-rank {
        h1 {
            margin: 0;
            text-align: center;
        }
        p {
            margin: 20px 0;
            font-size: 16px;
            text-align: center;
        }
    }
    .ings-det {
        .ings-det-head {
            border-top: 8px solid #d7d7d7;
            padding: 0 50px 20px;
            background: #f3f3f3;
            .col-md-4 {
                padding-left: 0;
            }
            h2 {
                margin: 20px 0;
                font-size: 20px;
                font-weight: normal;
                text-align: center;
            }
            label {
                float: left;
                width: 85px;
                margin: 0;
                line-height: 40px;
                font-size: 14px;
                text-align: right;
            }
            span {
                display: block;
                line-height: 40px;
                font-size: 14px;
            }
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
    }
    .ings-goods {
        display: none;
        width: 90%;
        margin: 0 auto;
    }

</style>